import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ArrowRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BlogArticles = () => {
  const [articles, setArticles] = useState([]);
  useEffect(() => {
    axios.get(`${API}/blog`).then(res => setArticles(res.data || [])).catch(() => {});
  }, []);
  if (articles.length === 0) return null;
  return (
    <section className="py-20 md:py-28 bg-[#060a13] relative overflow-hidden" id="blog">
      <div className="absolute top-1/3 left-0 w-[500px] h-[500px] bg-blue-500/5 rounded-full blur-[150px]" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Блог та поради</h2>
          <p className="text-lg text-slate-400">Корисні статті про доставку з Китаю та США</p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((a, i) => (
            <Link to={`/blog/${a.slug}`} key={i} className="group block bg-[#111827]/80 backdrop-blur-sm border border-slate-700/50 rounded-2xl overflow-hidden hover:border-blue-500/30 hover:shadow-[0_0_35px_-10px_rgba(59,130,246,0.3)] transition-all duration-500"
              data-testid={`blog-article-${i}`}>
              <div className="h-48 overflow-hidden relative">
                <img src={a.image} alt={a.title} loading="lazy" decoding="async" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500 opacity-70 group-hover:opacity-90" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#111827] to-transparent" />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-2 mb-3">
                  <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-semibold ${a.tag_color}`}>{a.tag}</span>
                  <span className="text-xs text-slate-500">{a.date}</span>
                </div>
                <h3 className="text-lg font-bold text-white mb-2 group-hover:text-blue-400 transition-colors">{a.title}</h3>
                <p className="text-sm text-slate-400 line-clamp-2">{a.summary}</p>
                <span className="inline-flex items-center gap-1 text-sm text-blue-400 font-medium mt-3 group-hover:text-blue-300">
                  Читати далі <ArrowRight className="w-3.5 h-3.5" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export const Blog = () => {
  const articles = [
    {
      title: 'Як працює особистий кабінет CargoAgs',
      tag: 'Інструкція',
      tagColor: 'bg-blue-100 text-blue-700',
      content: 'Після реєстрації ви отримуєте доступ до повного набору інструментів: відстеження посилок в реальному часі, перегляд рахунків та балансу, калькулятор вартості доставки, та можливість додавати власні посилки. Кожна посилка має унікальний трек-номер CAGS-XXXX для зручного відстеження.',
    },
    {
      title: 'Переваги роботи з B2B та B2C клієнтами',
      tag: 'Для бізнесу',
      tagColor: 'bg-orange-100 text-orange-700',
      content: 'CargoAgs — це надійний партнер як для великого бізнесу, так і для приватних замовників. Ми пропонуємо індивідуальні умови для B2B клієнтів: гнучкі тарифи, консолідацію вантажів, викуп товару та повне супроводження від замовлення до доставки. Для B2C — зручний сервіс з прозорими цінами.',
    },
    {
      title: 'Чому клієнти обирають CargoAgs',
      tag: 'Про нас',
      tagColor: 'bg-emerald-100 text-emerald-700',
      content: 'Наша головна цінність — це якісна робота та довіра клієнтів. Ми завжди йдемо назустріч: допомагаємо з розмитненням, консультуємо по вибору постачальника, пропонуємо найвигідніші маршрути. За 8+ років ми доставили понад 50 000 посилок з Китаю та побудували репутацію надійного карго-партнера.',
    },
    {
      title: 'Можливості особистого кабінету',
      tag: 'Функціонал',
      tagColor: 'bg-purple-100 text-purple-700',
      content: 'У вашому кабінеті доступно: баланс у USD з історією операцій, автоматичний розрахунок вартості доставки, оплата рахунків онлайн, заповнення даних отримувача для Нової Пошти, зміна пароля та повне управління вашими посилками. Все в одному місці — без зайвих дзвінків та листування.',
    },
  ];
  return (
    <section className="py-20 md:py-28 bg-[#0a0f1c]" id="blog">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Блог CargoAgs</h2>
          <p className="text-lg text-slate-400">Корисна інформація для наших клієнтів</p>
        </div>
        <div className="grid md:grid-cols-2 gap-6">
          {articles.map((a, i) => (
            <div key={i} className="bg-[#111827]/80 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-8 hover:border-slate-600 hover:shadow-[0_0_30px_-12px_rgba(59,130,246,0.2)] transition-all duration-300">
              <span className={`inline-block px-3 py-1 rounded-full text-xs font-semibold mb-4 ${a.tagColor}`}>{a.tag}</span>
              <h3 className="text-xl font-bold text-white mb-3">{a.title}</h3>
              <p className="text-slate-400 leading-relaxed">{a.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
